module.exports = __webpack_public_path__ + "img/wuye1.86babca9.jpg";